import { createAction } from 'redux-actions';

import { CLEAR_CLIENT_PROFILE_ENTRY_DETAILS } from '../../types';

export const clearClientProfileEntryDetails = createAction(CLEAR_CLIENT_PROFILE_ENTRY_DETAILS);


// WEBPACK FOOTER //
// ./src/features/client-profile/actions/clearActions/clearClientProfileEntryDetailsActions.js